import { sendPasswordResetEmail } from 'firebase/auth';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DASHBOARD } from "../constants/routes";
import { checkEmailAddressExistData } from '../context/PostFirbase';
import { auth } from '../firebase';


const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  
  const handleSubmit = async (e) => {

    e.preventDefault();
    setError('')
  
    try {
      const checkEmailExist = await checkEmailAddressExistData(email);
      if (checkEmailExist.length > 0) {
      await sendPasswordResetEmail(auth, email);
      setMsg("Password reset link sent successfully!");
    }else{
      setError('Email doesnot exist please sign up');
      alert("Email doesnot exist please signup");
      }
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };
  


  return (
    <div className='max-w-[700px] mx-auto  p-4 mt-20'>
      <div id="toast-success" className={` ${msg ? '' :'hidden'} flex items-center p-4 mb-4 w-full text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800`} role="alert">
    <div className="inline-flex flex-shrink-0 justify-center items-center w-8 h-8 text-green-500 bg-green-100 rounded-lg dark:bg-green-800 dark:text-green-200">
        <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path></svg>
        <span className="sr-only">Check icon</span>
    </div>
    <div className="ml-3 text-sm font-normal">{msg}</div>
    <button type="button"
    onClick={()=>setMsg('')} 
    className="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700" data-dismiss-target="#toast-success" aria-label="Close">
        <span className="sr-only">Close</span>
        <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
    </button>
</div>
      <div>
        <h1 className='text-center text-2xl font-bold py-2'>Forget Password</h1>
      </div>
      <form onSubmit={handleSubmit}>
        <div className='flex flex-col py-2'>
          <label className='text-sm '>Email Address</label>
          <input onChange={(e) => {setEmail(e.target.value); setError('')}} value={email} className='border p-1 rounded-md' type='email' />
          <p className=''>{error}</p>
        </div>
        
        <button className='border 
        border-red-500 bg-red-600 hover:bg-red-800 w-full p-1 my-2 text-white rounded-md'>
          Send
        </button>
      </form>
      <div className="relative flex items-center justify-center w-full mt-6 border border-t">
        <div className="absolute px-5 text-sm bg-white">Or Continue with </div>
      </div>
     <div className='flex justify-around'>

      <p className="mt-4 text-xs font-light text-center text-gray-700">
        {" "}
        Do you have an account?{" "}

        <Link to='/signin' className="font-medium text-red-600 hover:underline">
          Sign in.
        </Link>
      </p>
      <p className="mt-4 text-xs font-light text-center text-gray-700">
        {" "}
        Don't have an account?{" "}

        <Link to='/signup' className="font-medium text-red-600 hover:underline">
          Sign up.
        </Link>
      </p>
     </div>

    </div>
  );
};

export default ForgetPassword;
